module.exports = __webpack_public_path__ + "static/media/accountMenuIcon.152182dd.svg";